import AssetronOverlayDialog from '@assetron/web-common/components/common/AssetronOverlayDialog';
import SignupVerifyEmail from 'auth/src/components/signup/SignupVerifyEmail';
import { PASSWORD_RESET_PURPOSE } from '@assetron/common/constants/constant';
import HeaderFooterLayout from '@assetron/web-common/layout/HeaderFooterLayout';
import { useNavigation } from '../../navigation/useNavigation';
import useSignupData from '@assetron/common/hooks/useSignupData';
import useEmailVerification from '../../hooks/useEmailVerification';
import useDocumentTitle from '@assetron/web-common/components/common/useDocumentTitle';
import { useLocalization } from '@assetron/common/hooks/useLocalization';

function ResetPasswordEmailVerification() {
  const {
    navigateToResetPassword,
    navigateToResetPasswordCreatePassword,
    navigateToSignInLanding,
  } = useNavigation();
  const { clearInfo, userEmail } = useSignupData();

  const {
    isResendDisabled,
    otp,
    isInvalidOTP,
    handleOTPChange,
    onContinueClick,
    onResendClick,
    isLoading,
  } = useEmailVerification(
    userEmail,
    PASSWORD_RESET_PURPOSE,
    navigateToResetPasswordCreatePassword,
  );

  const handleClose = (): void => {
    clearInfo();
    navigateToSignInLanding();
  };

  const handleBack = (): void => {
    navigateToResetPassword();
  };

  const { t } = useLocalization();
  useDocumentTitle(t('resetPassword.pageTitle'));

  return (
    <HeaderFooterLayout>
      <AssetronOverlayDialog
        open
        isLogoVisible
        content={
          <SignupVerifyEmail
            otp={otp}
            isInvalidOTP={isInvalidOTP}
            isResendDisabled={isResendDisabled}
            onOtpChange={handleOTPChange}
            onContinueClick={onContinueClick}
            onResendClick={onResendClick}
            isLoading={isLoading}
          />
        }
        isBackVisible
        onClose={handleClose}
        onBack={handleBack}
      />
    </HeaderFooterLayout>
  );
}

export default ResetPasswordEmailVerification;
